<template>
  <div class="app-wrapper">
    <notification></notification>
    <router-view></router-view>
  </div>
</template>

<script>
import notification from './components/notifications/notificationBar';

export default {
    components: {
        notification
    }
}
</script>

<style lang="scss">
    @import "./scss/styles";
</style>
